import * as userRequest from "@/utils/userRequest";

export default async function checkManagementPackageService(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.post("helper/check-management-package", undefined, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ checkManagementPackageService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
